module.exports = __webpack_public_path__ + "static/media/Nederlandse_Taalunie.ce822eb3.jpeg";